/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_What_P2Inputs */

const en_home_what_p2 = /** @type {(inputs: Home_What_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you have used AutoCAD, CADCraft feels familiar within minutes. You type LINE, CIRCLE, OFFSET or TRIM at the command line, pick points with object snaps, use polar tracking and ortho, and repeat the last command with Enter, Space or a right-click. Drawings are organized with layers, annotated with associative dimensions, multileaders, tables and hatches, and laid out in paper space for plotting to scale.`)
};

/**
* | output |
* | --- |
* | "If you have used AutoCAD, CADCraft feels familiar within minutes. You type LINE, CIRCLE, OFFSET or TRIM at the command line, pick points with object snaps, u..." |
*
* @param {Home_What_P2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_what_p2 = /** @type {((inputs?: Home_What_P2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_What_P2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_what_p2(inputs)
});
export { home_what_p2 as "home.what.p2" }